import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function InfoCardTitle({ image, content }) {
  return (
    <Grid
      container
      justifyContent={`center`}
      alignItems={`center`}
      sx={{ mt: 2 }}
    >
      <Grid item xs={1}></Grid>
      <Grid item xs={3}>
        <Box sx={{ textAlign: "center" }}>{image}</Box>
      </Grid>
      <Grid item xs={1}>
        <img src={`/VerticalLine.png`} alt={``} width={`1`} height={`50`} />
      </Grid>
      <Grid item xs={7}>
        {content}
      </Grid>
    </Grid>
  );
}
